import Action from "./class.Action";

/**
 * Creates a bubble with some text/html in it.
 */
export default class RenderPrimitive extends Action {
	constructor(options) {
		super(options);
		this.initialize();
	}

	async initialize() {
		if (!this.model.html) {
			return this.onAdvance(this.$anchor);
		}

		const parent = this.getParent();
		let position = "teacher";
		if (parent && parent.center) {
			position = "center";
		}

		// Create a new bubble.
		var bubbleView = this.layoutView.placeBubble(
			this.$anchor,
			this.method,
			position
		);

		// Append the html content from our piece of the document.
		bubbleView.appendContent($("<div />").html(this.model.html));

		// Set the text align of the bubble.
		if (parent && parent.text_align) {
			bubbleView.setTextAlign(parent.text_align);
		}

		if (parent && parent.sticky && parent.center) {
			this.mainView.collapseThenUnsticky();
		}

		// Animate the bubble fading in.
		await this.animationController.FadeIn.start({bubbleView}).scroll();

		if (parent && parent.sticky && parent.center) {
			await bubbleView.sticky();
		}

		// Advance the script.
		this.onAdvance(bubbleView.$el);
	}
}
